module.exports = __webpack_public_path__ + "img/logo.babb15fd.svg";